import { Outlet, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import NavigationBar from "../NavigationBar"
import Background from '../Background';
import Header from '../Header';
import Chatbot from '../Chatbot';
const Layout =  ({logo,visibility,functions,pageList}) => {
  const location = useLocation();
  const currentPage = location.pathname; // Get the current pathname from the URL

  useEffect(() => {
    if (location.pathname === '/') {
      document.body.classList.add('intro-page');
    } else {
      document.body.classList.remove('intro-page');
    }
    return () => document.body.classList.remove('intro-page');
  }, [location.pathname]);

  return (
    <>
       <Header logo={logo}  visibility={visibility} functions={{functions}} 
      pageList={pageList} />

      <Outlet />
      <Background currentPage={currentPage}></Background>
      <Chatbot />
    </>
  )
};

export default Layout;